const http = require('../lib/httpClient');
const { getChannelId, getCookie, getEcommId } = require('../lib/browserData');
const { COOKIES } = require('../constants');

const sessionNotFoundError = {
  code: 'UPDATE_USER_ERROR_SESSION_NOT_FOUND',
  message: 'Session not found',
};
const updateUserError = {
  code: 'UPDATE_USER_ERROR',
  message: 'failed to update user personal data',
};
const endpoint = '/s/account/v2/profile';

async function catalystUpdateUser(userData, tenantId, catalystBaseUrl = '') {
  const sessionId = getCookie(COOKIES.SESSION.VALUE);

  if (!sessionId) return { data: undefined, errors: [sessionNotFoundError] };

  const result = await http.put(`${catalystBaseUrl}${endpoint}`, userData, {
    headers: {
      Authorization: sessionId,
      'x-channel-id': getChannelId(),
      'x-ecomm-name': getEcommId(tenantId),
    },
  });

  const { responseBody } = result || {};

  if (!responseBody) {
    return { data: undefined, errors: [updateUserError] };
  }

  if (responseBody.errors && responseBody.errors.length) {
    return { data: undefined, errors: responseBody.errors };
  }

  return { data: { ...responseBody }, errors: [] };
}

module.exports = catalystUpdateUser;
